"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnErrorMessagesPayment = exports.ReturnErrorMessagesBookings = void 0;
const response_codes_1 = require("../assets/constants/response_codes");
const strings_1 = require("../assets/strings/strings");
const message_utils_1 = __importDefault(require("../utils/message_utils"));
const setError = (data) => {
    const { errors } = data;
    const error = Array.isArray(errors) ? errors : [errors];
    const messageError = error.map(erro => {
        return `${erro.fieldName}' - '${erro.message}
    `;
    });
    return messageError;
};
const HandleErrorMessages = (data) => {
    if (data && data.booking && data.booking.errorCode !== 0) {
        switch (data.booking.errorCode) {
            case response_codes_1.BookingReservationCodes.error.BEDS_IP_UNAUTHORIZED:
                message_utils_1.default.error({
                    message: strings_1.BookingMessages.messageIPUnauthorizedBeds,
                    description: '',
                });
                break;
            case response_codes_1.BookingReservationCodes.error.BEDS_NO_AVAILABILITY:
                message_utils_1.default.error({
                    message: strings_1.BookingMessages.messageNoAvailability,
                    description: '',
                });
                break;
            default:
                message_utils_1.default.error({
                    description: strings_1.BookingMessages.messageGeneralRequestError,
                });
                break;
        }
    }
    else if (data && data.code) {
        switch (data.code) {
            case -16001:
                message_utils_1.default.error({
                    message: 'Ops! Não conseguimos prosseguir com a reserva.',
                    description: 'Código: 360.',
                });
                break;
            case response_codes_1.BookingReservationCodes.error.BOOKING_FAILED:
                message_utils_1.default.error({
                    description: strings_1.BookingMessages.messageGeneralRequestError,
                });
                break;
            case response_codes_1.BookingReservationCodes.error.ROOM_NOTFOUND:
                message_utils_1.default.error({
                    description: strings_1.BookingMessages.messageRoomNotFound,
                });
                break;
            case response_codes_1.BookingReservationCodes.error.VALIDATION_FIELDS:
                message_utils_1.default.error({
                    description: strings_1.BookingMessages.messageValidationFields,
                });
                break;
            default:
                message_utils_1.default.error({
                    description: strings_1.BookingMessages.messageGeneralRequestError,
                });
                break;
        }
    }
    else {
        message_utils_1.default.error({
            description: strings_1.BookingMessages.messageGeneralRequestError,
        });
    }
};
const ReturnErrorMessagesBookings = (data) => {
    if (data.booking && data.booking.errorCode !== 0) {
        switch (data.booking.errorCode) {
            case response_codes_1.BookingReservationCodes.error.BEDS_IP_UNAUTHORIZED:
                return strings_1.BookingMessages.messageIPUnauthorizedBeds;
                break;
            case response_codes_1.BookingReservationCodes.error.BEDS_NO_AVAILABILITY:
                return strings_1.BookingMessages.messageNoAvailability;
                break;
            default:
                return strings_1.BookingMessages.messageGeneralRequestError;
                break;
        }
    }
    else if (data.code) {
        switch (data.code) {
            case response_codes_1.BookingReservationCodes.error.BOOKING_FAILED:
                return strings_1.BookingMessages.messageGeneralRequestError;
                break;
            case response_codes_1.BookingReservationCodes.error.ROOM_NOTFOUND:
                return strings_1.BookingMessages.messageRoomNotFound;
                break;
            case response_codes_1.BookingReservationCodes.error.VALIDATION_FIELDS:
                setError(data);
                return `${strings_1.BookingMessages.messageValidationFields} : ${setError(data)}`;
                break;
            default:
                return strings_1.BookingMessages.messageGeneralRequestError;
                break;
        }
    }
    else {
        return strings_1.BookingMessages.messageGeneralRequestError;
    }
};
exports.ReturnErrorMessagesBookings = ReturnErrorMessagesBookings;
const ReturnErrorMessagesPayment = (data) => {
    if (data.code) {
        switch (data.code) {
            case response_codes_1.PaymentCodes.error.VALIDATION_FIELDS:
                return `${strings_1.PaymentMessages.messageValidationFields}
        ${setError(data)}`;
                break;
            default:
                return `${strings_1.PaymentMessages.messageGeneralRequestError}
        ${data.description}`;
                break;
        }
    }
    else {
        return `${strings_1.PaymentMessages.messageGeneralRequestError}
    ${data.description}`;
    }
};
exports.ReturnErrorMessagesPayment = ReturnErrorMessagesPayment;
exports.default = HandleErrorMessages;
